import { render, staticRenderFns } from "./NorthAmerica.vue?vue&type=template&id=4708a334&"
import script from "./NorthAmerica.vue?vue&type=script&lang=js&"
export * from "./NorthAmerica.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports